import { render } from "./ChargebeeUpsellSummaryItems.vue?vue&type=template&id=4db7363a&scoped=true"
import script from "./ChargebeeUpsellSummaryItems.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellSummaryItems.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellSummaryItems.vue?vue&type=style&index=0&id=4db7363a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db7363a"]])

export default __exports__